import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import RelatedIrwinRecord from './RelatedIrwinRecord';
import RelatedBulkUploadRecord from './RelatedBulkUploadRecord';
import RelatedWFMIRecord from './RelatedWFMIRecord';
import RelatedFireStatRecord from './RelatedFireStatRecord';
import RelatedFMISRecord from './RelatedFMISRecord';
import RelatedFODRecord from './RelatedFODRecord';
import RelatedCertificationRecord from './RelatedCertificationRecord';

import theme from '../../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
}

class RelatedRecordsDialog extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
      currentIndex: 0,
      hasData: false,
      incidentCount: 0,
      relatedRecords:[]
    };

  }

  handleBack = () =>
  {
    const previousVal = this.state.currentIndex - 1;
    this.setState({
      currentIndex: previousVal
    });
  }

  handleNext = () =>
  {
    const nextVal = this.state.currentIndex + 1;
    this.setState({
      currentIndex: nextVal
    });
  }
  
  getDisplayContent = () => {
    const currentRecord = this.state.relatedRecords[this.state.currentIndex];

    const panelMap = [
      { key: "IrwinID", exclude: "FireStatID", method: () => this.getIrwinPanel(currentRecord, this.state.irwinDeltas) },
      { key: "CertificationRecordID", method: () => this.getCertificationPanel(currentRecord) },
      { key: "WFMIID", method: () => this.getWFMIPanel(currentRecord) },
      { key: "BulkUploadID", method: () => this.getBulkUploadPanel(currentRecord) },
      { key: "FireStatID", method: () => this.getFireStatPanel(currentRecord) },
      { key: "FMISID", method: () => this.getFMISPanel(currentRecord) },
      { key: "FODID", method: () => this.getFODPanel(currentRecord) }
    ];

    for (const { key, exclude, method } of panelMap) {
      if (currentRecord.hasOwnProperty(key) && (!exclude || !currentRecord.hasOwnProperty(exclude))) {
        return method();
      }
    }

    return null; // fallback if no match is found
  };

  getIrwinPanel = (dataRecord, attributeDeltas) =>
  {
    return (<RelatedIrwinRecord record={dataRecord} AttributeDeltas={attributeDeltas}/>)
  }

  getCertificationPanel = (dataRecord, attributeDeltas) =>
  {
    return (<RelatedCertificationRecord record={dataRecord}/>)
  }

  getWFMIPanel = (dataRecord) =>
  {
    return (<RelatedWFMIRecord record={dataRecord}/>)
  }

  getBulkUploadPanel = (dataRecord) =>
  {
  return (<RelatedBulkUploadRecord record={dataRecord}/>)
  }

  getFireStatPanel = (dataRecord) =>
  {
      return (<RelatedFireStatRecord record={dataRecord}/>)
  }

  getFMISPanel = (dataRecord) =>
  {
      return (<RelatedFMISRecord record={dataRecord}/>)
  }

  getFODPanel = (dataRecord) =>
  {
      return (<RelatedFODRecord record={dataRecord}/>)
  }

  componentDidUpdate(prevProps)
  {
    const hasData = (this.props.relatedRecords);

    if (hasData !== this.state.hasData)
    {
      this.setState({
        hasData: hasData
      });
    }

    if (hasData && this.props.relatedRecords !== prevProps.relatedRecords)
    {
      const incidentTypes = [
        "FireStatIncidents",
        "IrwinIncidents",
        "BulkUploadIncidents",
        "WFMIIncidents",
        "FMISIncidents",
        "FODIncidents",
        "CertificationRecords"
      ];
      const { relatedRecords } = this.props;

      // Total count
      const totalIncidentCount = incidentTypes.reduce(
        (sum, type) => sum + (relatedRecords[type]?.length || 0),
        0
      );

      // Flatten all incidents into a single array
      const recordsArray = incidentTypes.flatMap(type => relatedRecords[type] || []);

      this.setState({
        incidentCount: totalIncidentCount,
        relatedRecords: recordsArray,
        irwinDeltas: this.props.relatedRecords.IrwinDeltas
      });
    }
  }

  render()
  {
    let panelContent = (this.state.hasData) ? ( this.getDisplayContent() ) : ("");

    let stepperContent = (this.state.hasData) ?
    (
      <MobileStepper
        steps={this.state.incidentCount}
        position="static"
        variant="text"
        activeStep={this.state.currentIndex}
        nextButton={
          <Button size="small" onClick={this.handleNext} disabled={this.state.currentIndex === this.state.incidentCount - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={this.handleBack} disabled={this.state.currentIndex === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      />
    )
    :
    (
      <CircularProgress color="secondary" size={110} className="loading-spinner-center-notransform" />
    );

  return (
    <Dialog
     title="Related Records"
     modal={true}
     contentStyle={{minWidth: '40%'}}
     open={this.props.open}
     autoScrollBodyContent={true}
     titleStyle={styles.errorDialogTitle}>
     <div style={{ minHeight: 400 }}>
        {panelContent}
        {stepperContent}
      </div>
     <DialogActions>
      <Button onClick={this.props.onRequestClose} color="primary">
        Close
      </Button>
    </DialogActions>
   </Dialog>
 )

  }
}

export default RelatedRecordsDialog;
